let bootPath = 'http://mallmgr.cesseon.com/api/';
// let bootPath = 'http://vps2.seekersoft.cn:8543/api/';
let picPath = 'http://mallmgr.cesseon.com/';
let sitePath = 'http://mall.cesseon.com/';
//"http://mallmgr.cesseon.com/api/" //SeekerBase/LoginValidateForPortal
//http://mallmgr.cesseon.com/api/Dic/GetProductSKUListInPortal?sku=1267425

export default {
    bootPath,
    picPath,
    sitePath
};
